import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Route.css';
import carImg from '../../assets/images/car-icon.png';
import calendarImg from '../../assets/images/calendar-icon.png';
import arrowImg from '../../assets/images/arrow-right-icon.png';
import editImg from '../../assets/images/edit-black-icon.png';
import filterImg from '../../assets/images/filter-icon.png';
import expandImg from '../../assets/images/arrow-down-icon.png';
import warningImg from '../../assets/images/warning-yellow-icon.png';
import Icon from '../../components/UI/Icon/Icon';
import Button from '../../components/UI/Button/Button';
import * as actionTypes from '../../store/actions';
import logError from '../../store/LogError';
import axios from '../../axios-trips';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import Request from '../Request/Request';

class Route extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      myNotifications: [],
      animate: 0
    };
  }

  highlight = (event) => {
    if (!this.props.highlighted && this.props.highlightRoutes) {
      this.props.highlightRoutes(this.props.id, true);
    }
  }

  highlightOff = (event) => {
    if (this.props.highlightRoutes) {
      this.props.highlightRoutes(this.props.id, false);
    }
  }

  componentDidMount() {
    if (this.props.externalNotifications) {
      const newNotifications = [];
      const myId = parseInt(this.props.id.substring(1, this.props.id.length), 10);
      Object.keys(this.props.externalNotifications).forEach(key => {
        if (this.props.externalNotifications[key].tripId === myId &&
          this.props.externalNotifications[key].notificationType === "Trip") {
          newNotifications.push(this.props.externalNotifications[key]);
        }
      });
      this.setState({ myNotifications: newNotifications });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.externalNotifications !== this.props.externalNotifications) {
      const newNotifications = [];
      const myId = parseInt(nextProps.id.substring(1, nextProps.id.length));
      Object.keys(nextProps.externalNotifications).forEach(key => {
        if (nextProps.externalNotifications[key].tripId === myId &&
          nextProps.externalNotifications[key].notificationType === "Trip") {
          newNotifications.push(nextProps.externalNotifications[key]);
        }
      });
      this.setState({ myNotifications: newNotifications });
    }

    if (this.props.tripDate !== nextProps.tripDate ||
      this.props.priority !== nextProps.priority ||
      this.props.capacity !== nextProps.capacity ||
      this.props.price !== nextProps.price ||
      this.props.car !== nextProps.car ||
      this.props.driver !== nextProps.driver ||
      this.props.priceComment !== nextProps.priceComment ||
      this.props.priceConfirmed !== nextProps.priceConfirmed ||
      this.props.note !== nextProps.note ||
      this.props.tripPoints !== nextProps.tripPoints ||
      this.props.dispatcher !== nextProps.dispatcher) {
      this.setState({ animate: this.state.animate + 1 });
    }
  }

  changeExpandedHandler = () => {
    let expanded = this.state.expanded;
    expanded = !expanded;
    this.setState({ expanded: expanded });
  }

  constructCard = () => {
    let localRequests = [];
    this.props.requests.forEach(request => {
      if (request.tripId === parseInt(this.props.id.substring(1, this.props.id.length), 10)) {
        localRequests.push({ ...request });
      }
    });

    let card = {
      id: this.props.id,
      archived: this.props.archived,
      origin: this.props.origin,
      destination: this.props.destination,
      tripDate: this.props.tripDate,
      capacity: this.props.capacity,
      price: this.props.price,
      priceComment: this.props.priceComment,
      priceConfirmed: this.props.priceConfirmed,
      priority: this.props.priority,
      driver: this.props.driver,
      car: this.props.car,
      carrierId: this.props.carrierId,
      carrierOkpo: this.props.carrierOkpo,
      carrierPartner: this.props.carrierPartner,
      carrierName: this.props.carrierName,
      carrierLs: this.props.carrierLs,
      carrierConfirmed: this.props.carrierConfirmed,
      managers: this.props.managers ? this.props.managers : [],
      note: this.props.note,
      tripPoints: this.props.tripPoints,
      dispatcher: this.props.dispatcher,
      requests: localRequests
    };

    console.log("Created card with id: " + card.id);

    return card;
  }

  formatDate(date) {
    if (date === undefined) {
      return null;
    }
    return date.substring(8, 10) + "/" + date.substring(5, 7) + "/" + date.substring(0, 4);
  }

  getId(id) {
    id = parseInt(id.substring(1, id.length));
    if (id < 10) {
      return "00" + id;
    } if (id < 100) {
      return "0" + id;
    }

    if (id.length == 3) {
      return id;
    } else {
      return id.toString().substring(id.toString().length - 3, id.toString().length);
    }
  }

  roundNum(num) {
    return Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100;
  }

  dragOverHandler = (event) => {
    if (this.props.onDragOver) {
      this.props.onDragOver(this.props.id);
    }
  }

  checkUnloading(unloading) {
    return unloading !== null && unloading !== undefined && unloading !== "";
  }

  calcUnloadings(localRequests) {
    let totalUnloadings = [];
    for (let i = 0; i < localRequests.length; i++) {
      if (!totalUnloadings.includes(localRequests[i].unloading) &&
        localRequests[i].unloading !== null &&
        localRequests[i].unloading !== "") {
        totalUnloadings.push(localRequests[i].unloading);
      }
    }
    return totalUnloadings.length;
  }

  getCapacityFilled(localRequests) {
    let indexedRequests = [];
    for (let i = 0; i < localRequests.length; i++) {
      let requestOrigin = -1;
      let requestDestination = -1;
      for (let j = 0; j < this.props.tripPoints.length; j++) {
        if (requestOrigin === -1 && this.props.tripPoints[j].location.locationName === localRequests[i].origin.locationName) {
          // Request's origin is at tripPoint j
          requestOrigin = j;
        }
        if (this.props.tripPoints[j].location.locationName === localRequests[i].destination.locationName) {
          // Request's destination is at tripPoint j
          requestDestination = j;
        }
      }
      if (requestOrigin !== -1 && requestDestination !== -1) {
        indexedRequests.push({ request: localRequests[i], origin: requestOrigin, destination: requestDestination });
      }
    }

    let maxCapacity = 0;
    for (let i = this.props.origin; i < this.props.destination; i++) {
      let pointCapacity = 0;
      for (let j = 0; j < indexedRequests.length; j++) {
        if (indexedRequests[j].origin < i + 1 && indexedRequests[j].destination > i) {
          pointCapacity += indexedRequests[j].request.weight;
        }
      }
      maxCapacity = Math.max(maxCapacity, pointCapacity);
    }

    return maxCapacity;
  }

  openTrip = (ev) => {
    ev.preventDefault();
    this.props.setTripHandler(this.constructCard());
    if (this.props.role === "ROLE_DISPATCHER") {
      this.updateNotifications();
    }
  }

  updateNotifications() {
    const notificationIds = [...this.state.myNotifications.map(obj => obj.id)];
    axios({
      method: 'post',
      url: '/api/v1/notifications/open',
      data: notificationIds,
      headers: { 'Authorization': 'Bearer ' + this.props.access_token },
    })
      .then(response => {
        this.removeNotificationsFrontend(notificationIds);
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/notifications/open'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
  }

  removeNotificationsFrontend(notificationIds) {
    let updatedNotifications = {};
    Object.keys(this.props.externalNotifications).forEach((key, i) => {
      if (!notificationIds.includes(key)) {
        updatedNotifications[key] = { ...this.props.externalNotifications[key] };
      }
    });
    if (this.state.myNotifications.length > 0) {
      this.props.onSetExternalNotifications(updatedNotifications);
    }
  }

  filterRoute = (ev) => {
    ev.preventDefault();
    if (this.props.filterRoute) {
      this.props.filterRoutes(null);
    } else {
      this.props.filterRoutes(this.props.id);
    }
  }

  render() {

    let bottomClass = [classes.Bottom];
    let expandArrowClass = classes.ExpandIcon;

    if (this.state.expanded) {
      bottomClass.push(classes.Expanded);
    }

    let localRequests = [];
    let foundWarning = false;
    for (let i = 0; i < this.props.requests.length; i++) {
      let requestOrigin = -1;
      let requestDestination = -1;
      for (let j = 0; j < this.props.tripPoints.length; j++) {
        if (requestOrigin === -1 && this.props.tripPoints[j].location.locationName === this.props.requests[i].origin.locationName) {
          // Request's origin is at tripPoint j
          requestOrigin = j;
        }
        if (this.props.tripPoints[j].location.locationName === this.props.requests[i].destination.locationName) {
          // Request's destination is at tripPoint j
          requestDestination = j;
        }
      }

      if (requestOrigin < this.props.destination && requestDestination > this.props.origin) {
        localRequests.push(this.props.requests[i]);
      }

      if (requestOrigin === -1 || requestDestination === -1 || requestDestination <= requestOrigin) {
        localRequests.push({ ...this.props.requests[i], warning: true });
        foundWarning = true;
      }
    }

    let capacityText = 'тонна';
    if (this.props.capacity !== 1) {
      capacityText = 'тонн';
    }

    let capacityFilled = this.getCapacityFilled(localRequests);
    let filled = capacityFilled / this.props.capacity * 100
    let filledExcess = capacityFilled - this.props.capacity;
    let filledActual = filled > 100 ? 100 - filledExcess / capacityFilled * 100 : filled;
    let proportionFilled = (Math.min(Math.max(filledActual, 3), 96)) + "%";
    let proportionAvailable = Math.max(Math.min(96, (capacityFilled > this.props.capacity ? 100 - filledActual : 100 - filledActual)), 3) + "%";
    let capacityFilledClass = [classes.TripCapacityAvailable];
    if (filled > 100) {
      capacityFilledClass.push(classes.OverfilledCapacity);
    }
    let filledVisible = filled > 0 && this.props.capacity > 0 ? "inline-block" : "none";
    let filledAvailable = capacityFilled !== this.props.capacity ? "inline-block" : "none";
    let priority = classes.p3;
    if (this.props.priority === "П3") {
      priority = classes.p3;
    } else if (this.props.priority === "П2") {
      priority = classes.p2;
    } else if (this.props.priority === "П1") {
      priority = classes.p1;
    }

    let routeText = (
      this.props.tripPoints.map((tripPoint, index) => {
        return (
          <Aux>
            {
              index < this.props.tripPoints.length - 1 ?
                <Aux>
                  <strong> {tripPoint.location.locationName}</strong> через
                </Aux>
                :
                <Aux>
                  &nbsp;в <strong> {tripPoint.location.locationName}</strong>
                </Aux>
            }
          </Aux>
        );
      })
    );

    let routeHeading = (
      this.props.tripPoints.map((tripPoint, index) => {
        return (
          <Aux>
            {
              index < this.props.tripPoints.length - 1 ?
                <Aux>
                  <p
                    key={index}
                    className={index === this.props.origin || index === this.props.destination ? classes.Bold : null}>
                    {tripPoint.location.locationName}
                  </p>
                  <Icon iconClass={classes.ArrowIcon} iconSource={arrowImg} iconAlt='' />
                </Aux>
                :
                <Aux>
                  <p
                    key={index}
                    className={index === this.props.origin || index === this.props.destination ? classes.Bold : null}>
                    {tripPoint.location.locationName}
                  </p>
                </Aux>
            }
          </Aux>
        );
      })
    );

    let noteText = null;
    if (this.props.note) {
      let note = this.props.note;
      if (note.length > 40) {
        note = this.props.note.substring(0, 40) + "...";
      }
      noteText = (<div>Коментар:<br /><p>{note}</p></div>);
    }

    let headerClasses = [classes.Header];
    if (this.props.carrierConfirmed) {
      headerClasses.push(this.props.highlighted ? classes.HeaderBrightGreenHighlighted : classes.HeaderBrightGreen);
    } else if (this.props.priceConfirmed) {
      headerClasses.push(this.props.highlighted ? classes.HeaderLightGreenHighlighted : classes.HeaderLightGreen);
    } else if (parseFloat(this.props.price) === 0) {
      headerClasses.push(this.props.highlighted ? classes.HeaderWhiteHihlighted : classes.HeaderWhite);
    } else {
      headerClasses.push(this.props.highlighted ? classes.HeaderOrangeHighlighted : classes.HeaderOrange);
    }

    let myRoute = (
      <div
        className={classes.Route}
        onMouseEnter={this.highlight}
        onMouseLeave={this.highlightOff}
        onDragOver={this.dragOverHandler}
        style={
          this.props.style ?
            this.props.style :
            { zIndex: this.props.extraRoutes ? this.props.extraRoutes.length + 1 : 0, margin: this.props.extraRoutes ? "0px" : null }
        } >

        <div key={this.state.animate} className={headerClasses.join(' ')}>
          <div className={classes.HeaderMain}>
            {
              this.props.role === "ROLE_ADMIN" || this.props.role === "ROLE_DISPATCHER" || this.props.role === "ROLE_MANAGER" || this.props.role === "ROLE_RULER" ?
                <div className={classes.HeaderAction1} onClick={this.openTrip}>
                  <Icon iconClass={expandArrowClass} iconSource={editImg} iconAlt='' />
                </div>
                : null
            }

            {
              this.props.filterRoutes &&
              <div
                className={[classes.HeaderAction2, this.props.filterRoute ? classes.FilterActive : null].join(' ')}
                onClick={this.filterRoute}>
                <Icon iconClass={[expandArrowClass, classes.IconRoundedBorder].join(' ')} iconSource={filterImg} iconAlt='' />
              </div>
            }

            <div className={classes.TripTitle} onClick={this.props.extraRoutes ? this.filterRoute : this.changeExpandedHandler}>
              <Icon iconClass={classes.CarIcon} iconSource={carImg} iconAlt='' />
              <p>{this.getId(this.props.id)}.&nbsp;</p>
              {routeHeading}

              {this.state.myNotifications.length > 0 ?
                <div className={classes.NotificationCount} onClick={this.openTrip}>
                  <p className={classes.NotificationText}>{this.state.myNotifications.length}</p>
                </div>
                : null}
            </div>

            <div className={classes.TripDate} onClick={this.changeExpandedHandler}>
              <Icon iconClass={classes.CalendarIcon} iconSource={calendarImg} iconAlt='' className={classes.CalendarIcon} />
              <p>{this.formatDate(this.props.tripDate)}</p>

              {
                foundWarning ?
                  <Icon iconClass={classes.WarningIcon} iconSource={warningImg} iconAlt='' />
                  : null
              }

              <div className={classes.TripPriority + " " + priority} onClick={this.changeExpandedHandler}>
                {this.props.priority}
              </div>
            </div>

            <div className={classes.TripCapacity} onClick={this.changeExpandedHandler}>
              <p className={classes.CapacityText}>({this.props.capacity})</p>
              <div className={classes.TripCapacitySlider}>
                <div className={classes.TripCapacityFilled} style={{ width: proportionFilled, display: filledVisible }}>
                  <p className={classes.CapacityFilledText}>{this.roundNum(capacityFilled)}</p>
                </div>
                <div className={capacityFilledClass.join(' ')} style={{ width: proportionAvailable, display: filledAvailable }}>
                  <p className={classes.CapacityAvailableText}>
                    {this.props.capacity > capacityFilled ?
                      this.roundNum((capacityFilled - this.props.capacity) * -1) :
                      this.roundNum((this.props.capacity - capacityFilled) * -1)}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={bottomClass.join(' ')}>
          <div className={classes.Body} >
            <div>З {routeText}</div>
            <div>Дата: {this.props.tripDate ? this.props.tripDate.substring(0, 10) : ""}</div>
            <div>Вага (тонн): {this.roundNum(this.props.capacity)} {capacityText} ({this.roundNum(capacityFilled)} / {this.roundNum(this.props.capacity - capacityFilled)})</div>
            {noteText}
            {localRequests.length > 0 ?
              <div>Вивантаження: {this.calcUnloadings(localRequests)}</div>
              :
              <div><em>Немає Вивантажень</em></div>}
            {this.props.dispatcher ? <div>Диспетчер: {this.props.dispatcher}</div> : null}
            {localRequests.length > 0 ?
              <div>Заявки ({localRequests.length}):</div>
              :
              <div><em>Немає Заявок</em></div>}
            {localRequests.length > 0 ?
              localRequests.map(request => {
                return (
                  <Request
                    key={"R" + request.id}
                    id={"R" + request.id}
                    hasRoute
                    origin={request.origin.locationName}
                    destination={request.destination.locationName}
                    manager={request.manager}
                    weight={request.weight}
                    requestTripDate={request.requestTripDate}
                    dateFlexibility={request.dateFlexibility}
                    warning={request.warning}
                    priority={request.priority}
                    initiator={request.initiator}
                    requestType={request.requestType}
                    partialLoad={request.partialLoad}
                    tripId={request.tripId}
                    moneyRequests={request.moneyRequests}
                    unloading={request.unloading}
                    unloadAfter={request.unloadAfter}
                    sorting={request.sorting}
                    accepted={request.accepted}
                    setRequestHandler={this.props.setRequestHandler}
                    highlighted={request.highlighted}
                    startDrag={this.props.startDrag}
                    stopDrag={this.props.stopDrag} />
                );
              })
              : null}
          </div>
        </div>
      </div>
    );

    return (
      <Aux>
        {
          this.props.extraRoutes ?
            <div
              className={classes.RoutesStacked}
              style={{
                marginTop: this.props.extraRoutes.length * 10 + "px",
                marginRight: this.props.extraRoutes.length * 10 + "px"
              }}>
              {myRoute}
              {
                this.props.extraRoutes.map((route, index) => (
                  <Route
                    key={"T" + route.id + "" + index}
                    id={"T" + route.id}
                    type={route.type}
                    origin={route.origin}
                    destination={route.destination}
                    tripDate={route.tripDate}
                    capacity={route.capacity}
                    priority={route.priority}
                    price={route.price}
                    priceComment={route.priceComment}
                    priceConfirmed={route.priceConfirmed}
                    carrierId={route.carrierId}
                    carrierOkpo={route.carrierOkpo}
                    carrierPartner={route.carrierPartner}
                    carrierName={route.carrierName}
                    carrierLs={route.carrierLs}
                    carrierConfirmed={route.carrierConfirmed}
                    driver={route.driver}
                    car={route.car}
                    highlighted={this.propshighlighted}
                    highlightRoutes={this.props.highlightRoutes}
                    filterRoutes={this.props.filterRoutes}
                    filterRoute={this.props.filterRoute}
                    managers={route.managers}
                    dispatcher={route.dispatcher}
                    note={route.note}
                    tripPoints={route.tripPoints}
                    setTripHandler={this.props.setTripHandler}
                    requests={route.requests ? route.requests : []}
                    startDrag={this.initialiseDrag}
                    stopDrag={this.stopDrag}
                    setRequestHandler={this.props.setRequestHandler}
                    from={this.props.from}
                    to={this.props.to}
                    style={{
                      marginLeft: (index + 1) * 10 + "px",
                      marginTop: -(index + 1) * 10 + "px",
                      zIndex: this.props.extraRoutes.length - index
                    }} />
                ))
              }

            </div>
            :
            myRoute
        }
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    dragInitialData: state.dragInitialData,
    dragOverObj: state.dragOverObj,
    locations: state.locations,
    role: state.role,
    routes: state.routes,
    externalNotifications: state.externalNotifications,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({
      type: actionTypes.ADD_NOTIFICATION,
      notification: notification,
      notificationType: notificationType
    }),
    onDragOver: (dragOverObj) => dispatch({
      type: actionTypes.DRAG_OVER_OBJ,
      dragOverObj: dragOverObj
    }),
    onSetExternalNotifications: (externalNotifications) => dispatch({
      type: actionTypes.SET_EXTERNAL_NOTIFICATIONS,
      externalNotifications: externalNotifications
    }),
    onSetRoutes: (routes) => dispatch({
      type: actionTypes.ROUTES,
      routes: routes
    })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Route);



// WEBPACK FOOTER //
// ./src/containers/Route/Route.js